export const versions = { revisionDate: "2020-03-29 13:07", revision: "dec14c61", branch: "master" };
